import { supabase } from "@/lib/supabase";

const AVATAR_BUCKET = "avatars";
const MAX_BYTES = 5 * 1024 * 1024; // 5 MB
const ALLOWED = ["image/jpeg", "image/png", "image/webp", "image/gif"];

export function validateAvatar(file) {
  if (!file) return "No file selected.";
  if (!ALLOWED.includes(file.type)) return "Use JPG, PNG, WEBP or GIF.";
  if (file.size > MAX_BYTES) return "Keep it under 5 MB.";
  return null;
}

export async function uploadAvatar(file, userId) {
  if (!file || !userId) return null;
  const ext = (file.name.split(".").pop() || "jpg").toLowerCase().replace(/[^a-z0-9]/g, "");
  const path = `${userId}/avatar-${Date.now()}.${ext || "jpg"}`;
  const { error } = await supabase.storage.from(AVATAR_BUCKET).upload(path, file, {
    cacheControl: "3600",
    upsert: true,
    contentType: file.type || "image/jpeg",
  });
  if (error) throw error;
  const { data } = supabase.storage.from(AVATAR_BUCKET).getPublicUrl(path);
  return data.publicUrl;
}

export async function deleteAvatarByUrl(url) {
  if (!url || !url.includes(`/${AVATAR_BUCKET}/`)) return;
  const path = url.split(`/${AVATAR_BUCKET}/`)[1];
  if (!path) return;
  await supabase.storage.from(AVATAR_BUCKET).remove([path]);
}
